import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useStateValue } from "./providers/StateProvider";
import Login from "./components/Login";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Chat from "./components/Chat";
import Welcome from "./components/Welcome";
import "./App.css";

function App() {
  const [{ user }] = useStateValue();

  useEffect(() => {
    let elem = document.getElementById("messages");
    if (elem) elem.scrollTop = elem.scrollHeight;
  }, []);

  return (
    <div className={user ? "app" : "app__login"}>
      <Router>
        {!user ? (
          <Login />
        ) : (
          <>
            <Header />

            <div className="app__body">
              <Sidebar />

              <Switch>
                <Route path="/room/:roomId" component={Chat} />
                <Route exact path="/" component={Welcome} />
                <Redirect to="/" />
              </Switch>
            </div>
          </>
        )}
      </Router>
    </div>
  );
}

export default App;
